(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onna-why-onna"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.onna-why:not([data-onna-ready])');

    sections.forEach((section) => {
      section.setAttribute('data-onna-ready', 'true');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });

      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
